import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
const TermsAndConditionsPage = lazy(
    () => import('Pages/Common/TermsAndConditions'),
);
const PrivacyPolicyPage = lazy(() => import('Pages/Common/PrivacyPolicy'));
const NotFoundPage = lazy(() => import('Pages/Common/NotFound'));
const MaintenancePage = lazy(() => import('Pages/Common/Maintenance'));
const ResetPasswordPage = lazy(() => import('Pages/Common/ResetPassword'));
const DebugQuestionPage = lazy(
    () => import('Pages/Common/DebugQuestion/DebugQuestionPage'),
);
const OpenCheckout = lazy(() =>
    import('Pages/Protected/Account/Subscriptions/SubscriptionCheckout').then(
        (module) => ({
            default: module.OpenSubscriptionManagementPage,
        }),
    ),
);

const commonRoutes: RouteObject = {
    path: '/',
    children: [
        {
            path: 'terms-and-conditions',
            element: <TermsAndConditionsPage />,
        },
        {
            path: 'privacy-policy',
            element: <PrivacyPolicyPage />,
        },
        {
            path: 'maintenance',
            element: <MaintenancePage />,
        },
        {
            path: '*',
            element: <NotFoundPage />,
        },
        {
            path: '/password/reset/:token/:email',
            element: <ResetPasswordPage />,
        },
        {
            path: '/open-checkout',
            element: <OpenCheckout />,
        },
        // Dev only: render a single onboarding question screen by id
        ...(process.env.NODE_ENV === 'development'
            ? [
                  {
                      path: '/debug/question/:id',
                      element: <DebugQuestionPage />,
                  },
              ]
            : []),
    ],
};

export default commonRoutes;
